var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
var _hoisted_1 = { class: "text-lg sm:text-2xl font-medium" };
var _hoisted_2 = {
    key: 0,
    class: "mt-5"
};
var _hoisted_3 = { class: "flex justify-center" };
import { computed, nextTick, ref, watch } from 'vue';
import { CoreStore } from '@student/modules/store';
import PassData from '@common/utils/PassData';
import Api from '@student/modules/api/api';
import Auth from '@common/modules/auth';
import Message from '@common/ui/EMessage/Message';
import EInputField from '@common/ui/EForm/fields/EInputField.vue';
import { useForm, useIsFormDirty, useIsFormValid } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import EInputPhoneField from '@common/ui/EForm/fields/EInputPhoneField.vue';
import { useRoute, useRouter } from 'vue-router';
import EInputNumberField from '@common/ui/EForm/fields/EInputNumberField.vue';
import { z } from 'zod';
import { useI18n } from 'vue-i18n';
import { isValidPhoneNumberV2 } from '@common/ui/EInputPhone/utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RequestUserInfo',
    setup: function (__props) {
        var _this = this;
        var t = useI18n().t;
        var visible = ref(false);
        var formLoading = ref(false);
        var _a = useForm({
            validationSchema: toTypedSchema(z.object({
                name: z.string().min(1, t('validation.enterName')),
                customFields: z.record(z.string(), z.union([
                    z.string().superRefine(function (value, ctx) {
                        var id = ctx.path[ctx.path.length - 1];
                        var field = customFields.value.find(function (f) { return f.id === id; });
                        if ((field === null || field === void 0 ? void 0 : field.type) === 'phone' && !isValidPhoneNumberV2(value)) {
                            ctx.addIssue({
                                code: z.ZodIssueCode.custom,
                                message: t('validation.enterField'),
                                path: ctx.path
                            });
                        }
                    }),
                    z.number()
                ]).refine(function (e) { return e; }, t('validation.enterField')))
            })),
            initialValues: {
                name: '',
                customFields: {}
            }
        }), values = _a.values, resetForm = _a.resetForm, handleSubmit = _a.handleSubmit;
        var isValid = useIsFormValid();
        var isDirty = useIsFormDirty();
        var customFields = ref([]);
        var user = computed(function () { return CoreStore.user; });
        var route = useRoute();
        var router = useRouter();
        var init = function () { return __awaiter(_this, void 0, void 0, function () {
            var requestMissingUserData, userFields, fields, filledFieldsIds_1, notFilled, notFilled_1, notFilled_1_1, notFilledField;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // ну тут типа эээ
                    // если оплата на лендосе, то не показываем
                    return [4 /*yield*/, nextTick()];
                    case 1:
                        // ну тут типа эээ
                        // если оплата на лендосе, то не показываем
                        _b.sent();
                        if (route.name === null || route.name === 'courseAbout')
                            return [2 /*return*/];
                        customFields.value = [];
                        requestMissingUserData = PassData.requestMissingUserData;
                        if (!requestMissingUserData)
                            return [2 /*return*/];
                        return [4 /*yield*/, Api.getUserFields()];
                    case 2:
                        userFields = (_b.sent()).data;
                        fields = {
                            name: userFields.user.userName,
                            customFields: {}
                        };
                        if (!userFields.user.userName || userFields.user.userName === t('user.unknown')) {
                            fields.name = '';
                        }
                        if (requestMissingUserData) {
                            customFields.value = [];
                            filledFieldsIds_1 = userFields.values.filter(function (e) { return String(e.value).length > 0; }).map(function (e) { return e.field; });
                            notFilled = userFields.fields.filter(function (e) { return !filledFieldsIds_1.includes(e.id); });
                            try {
                                for (notFilled_1 = __values(notFilled), notFilled_1_1 = notFilled_1.next(); !notFilled_1_1.done; notFilled_1_1 = notFilled_1.next()) {
                                    notFilledField = notFilled_1_1.value;
                                    // TODO нам надо null в таких случаях прокидывать или что-то еще
                                    fields.customFields[notFilledField.id] = notFilledField.type === 'phone' ? '+7' : '';
                                    customFields.value.push(notFilledField);
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (notFilled_1_1 && !notFilled_1_1.done && (_a = notFilled_1.return)) _a.call(notFilled_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        resetForm({
                            values: fields,
                        });
                        if (Object.keys(fields.customFields).length > 0 || !fields.name) {
                            show();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        watch([user, route], init, { immediate: true, deep: true });
        var show = function () {
            visible.value = true;
        };
        var hide = function () {
            visible.value = false;
        };
        var saveForm = handleSubmit(function (values, ctx) { return __awaiter(_this, void 0, void 0, function () {
            var name, res, fields, _a, _b, field;
            var e_2, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        formLoading.value = true;
                        name = values.name;
                        if (!(name !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Api.updateUser({ name: name })];
                    case 1:
                        res = (_d.sent()).data;
                        Auth.setUser(res);
                        _d.label = 2;
                    case 2:
                        if (!(customFields.value.length > 0)) return [3 /*break*/, 4];
                        fields = {};
                        try {
                            for (_a = __values(customFields.value), _b = _a.next(); !_b.done; _b = _a.next()) {
                                field = _b.value;
                                fields[field.id] = values.customFields[field.id];
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [4 /*yield*/, Api.setUserFields({ fields: fields })];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        formLoading.value = false;
                        Message.success(t('validation.success'));
                        hide();
                        return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            var _component_e_button = _resolveComponent("e-button");
            var _component_e_dialog = _resolveComponent("e-dialog");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_e_dialog, {
                    "close-by-user": false,
                    visible: visible.value,
                    name: "request-user-info",
                    "center-content": ""
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('modal.title')), 1),
                            (_unref(values).name !== undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(EInputField, {
                                        disabled: formLoading.value,
                                        placeholder: _unref(t)('form.namePlaceholder'),
                                        name: "name",
                                        tabindex: "0",
                                        autofocus: ""
                                    }, null, 8, ["disabled", "placeholder"])
                                ]))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customFields.value, function (customField) {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: customField.id,
                                    class: "mt-5"
                                }, [
                                    (customField.type === 'phone')
                                        ? (_openBlock(), _createBlock(EInputPhoneField, {
                                            key: 0,
                                            disabled: formLoading.value,
                                            name: "customFields.".concat(customField.id),
                                            placeholder: customField.title,
                                            size: "large"
                                        }, null, 8, ["disabled", "name", "placeholder"]))
                                        : (customField.type === 'number')
                                            ? (_openBlock(), _createBlock(EInputNumberField, {
                                                key: 1,
                                                disabled: formLoading.value,
                                                name: "customFields.".concat(customField.id),
                                                placeholder: customField.title,
                                                size: "large"
                                            }, null, 8, ["disabled", "name", "placeholder"]))
                                            : (_openBlock(), _createBlock(EInputField, {
                                                key: 2,
                                                disabled: formLoading.value,
                                                name: "customFields.".concat(customField.id),
                                                placeholder: customField.title,
                                                size: "large"
                                            }, null, 8, ["disabled", "name", "placeholder"]))
                                ]));
                            }), 128)),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_e_button, {
                                    disabled: !_unref(isValid) || !_unref(isDirty),
                                    loading: formLoading.value,
                                    class: "mt-5",
                                    type: "primary",
                                    onClick: _unref(saveForm)
                                }, {
                                    default: _withCtx(function () { return [
                                        _createTextVNode(_toDisplayString(_unref(t)('form.saveButton')), 1)
                                    ]; }),
                                    _: 1
                                }, 8, ["disabled", "loading", "onClick"])
                            ])
                        ])
                    ]; }),
                    _: 1
                }, 8, ["visible"])
            ]));
        };
    }
});
